import {
	AttributeSubtype,
	BaseAttribute,
} from '../../ontology/types/attributeTypes';
import { boolStringToBool, emptyStringToNull } from '../common/helpers';
import {
	DescribeAttrFormValues,
	DescribeAttrPayload,
} from './describeAttributeTypes';

export const describeAttrFormDefaults = (
	attr: BaseAttribute
): DescribeAttrFormValues => ({
	singular: attr.singular,
	plural: attr.plural,
	definition: attr.subtype ?? '',
	type: attr.type,
	otherType: attr.subtype ?? '',
	defaultValue: attr.defaultValue ?? '',
	isRequired: 'false',
});

export const describeAttrFormToPayload = (
	formValues: DescribeAttrFormValues
): DescribeAttrPayload => ({
	singular: formValues.singular,
	plural: formValues.plural,
	definition: emptyStringToNull(formValues.definition),
	type: formValues.type,
	otherType: emptyStringToNull(
		formValues.otherType
	) as AttributeSubtype | null,
	defaultValue: emptyStringToNull(formValues.defaultValue),
	isRequired: boolStringToBool(formValues.isRequired),
});
